
import { defineComponent, PropType } from "vue";
import {
    IAcademicCompetenciesModel,
    ITeachersModel,
    IAcademicYearModel,
    ISaberTypesModel,
    ISystemSubjectsModel,
} from "@/interfaces/modules";
import TeachersService from "@/api/Aula/TeachersService";
import AcademicYearService from "@/api/Configuration/AcademicYearService";
import SaberTypesService from "@/api/AcademicBase/SaberTypesService";
import SystemSubjectsService from "@/api/Academic/SystemSubjectsService";
import AcademicCompetenciesService from "@/api/AcademicBase/AcademicCompetenciesService";
import router from "@/router";
import store from "@/store";

export default defineComponent({
    name: "AcademicCompetencyBasicDataTab",
    props: {
        competency: {
            type: Object as PropType<IAcademicCompetenciesModel | null>,
            required: true,
        },
    },
    data() {
        return {

            form: {
                loading: true,
                dialog: false,
                valid: false,
                wasValidated: false,
                record: {} as IAcademicCompetenciesModel,
                rules: {
                    required: [(v: any) => !!v || "Este campo es requerido"],
                },
            },
            teachers: [] as ITeachersModel[],
            academicYears: [] as IAcademicYearModel[],
            saberTypes: [] as ISaberTypesModel[],
            subjects: [] as ISystemSubjectsModel[],
            loading: true,
            saving: false,
        };
    },
    computed: {
        formRecord(): any {
            return this.$refs.formRecord;
        },
    },
    async mounted() {
        await this.load();
        if (this.competency?.Id) {
            this.form.record = await AcademicCompetenciesService.GetAcademicCompetenciesById({ Id: this.competency.Id } as any);
        }
    },
    methods: {
        async load() {
            this.loading = true;
            try {
                this.teachers = await TeachersService.GetTeachers();
                this.academicYears = await AcademicYearService.GetAcademicYears();
                this.saberTypes = await SaberTypesService.GetSaberTypes();
                this.subjects = await SystemSubjectsService.GetSubjects();
            } finally {
                this.loading = false;
            }
        },

        async save() {
            try {
                this.form.loading = true;
                const res = await AcademicCompetenciesService.PostAcademicCompetencies(this.form.record);
                store.dispatch("core/popupDialog", {
                    text: "Registro completado con éxito.",
                    type: "success",
                    showCancelButton: false,
                });
                this.form.loading = false;
                router.push(`/base-academic/competencies-tab-content/${res.Id}`);
                location.reload();
            } catch (err: any) {
                this.form.loading = false;
                store.dispatch("core/popupDialog", {
                    text: `Error: ${err?.response?.data?.message || err?.message}`,
                    type: "error",
                    showCancelButton: false,
                });
            }
        },

        cancel(_file: any) {
            router.push({ name: "competencies" });
        },

    },
});
